'use strict';

exports.__esModule = true;
exports.get = get;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _merge = require('./merge');

var _merge2 = _interopRequireDefault(_merge);

function get(target, keys) {
  for (var i = 0; target !== undefined && i < keys.length; i++) {
    target = target[keys[i]];
  }

  return target;
}

function set(target, keys, value) {
  if (keys.length) {
    var head = keys[0];
    var clone = _merge2['default']({}, target);

    clone[head] = keys.length > 1 ? set(clone[head] || {}, keys.slice(1), value) : value;

    return clone;
  } else {
    return value;
  }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy91cGRhdGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7cUJBQWtCLFNBQVM7Ozs7QUFFcEIsU0FBUyxHQUFHLENBQUUsTUFBTSxFQUFFLElBQUksRUFBRTtBQUNqQyxPQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxNQUFNLEtBQUssU0FBUyxJQUFJLENBQUMsR0FBRyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO0FBQzVELFVBQU0sR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUE7R0FDekI7O0FBRUQsU0FBTyxNQUFNLENBQUE7Q0FDZDs7QUFFTSxTQUFTLEdBQUcsQ0FBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRTtBQUN4QyxNQUFJLElBQUksQ0FBQyxNQUFNLEVBQUU7QUFDZixRQUFJLElBQUksR0FBSSxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFDbkIsUUFBSSxLQUFLLEdBQUcsbUJBQU0sRUFBRSxFQUFFLE1BQU0sQ0FBQyxDQUFBOztBQUU3QixTQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDLE1BQU0sR0FBRyxDQUFDLEdBQUcsR0FBRyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLENBQUMsR0FBRyxLQUFLLENBQUE7O0FBRXBGLFdBQU8sS0FBSyxDQUFBO0dBQ2IsTUFBTTtBQUNMLFdBQU8sS0FBSyxDQUFBO0dBQ2I7Q0FDRiIsImZpbGUiOiJzcmMvdXBkYXRlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IG1lcmdlIGZyb20gJy4vbWVyZ2UnXG5cbmV4cG9ydCBmdW5jdGlvbiBnZXQgKHRhcmdldCwga2V5cykge1xuICBmb3IgKHZhciBpID0gMDsgdGFyZ2V0ICE9PSB1bmRlZmluZWQgJiYgaSA8IGtleXMubGVuZ3RoOyBpKyspIHtcbiAgICB0YXJnZXQgPSB0YXJnZXRba2V5c1tpXV1cbiAgfVxuXG4gIHJldHVybiB0YXJnZXRcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHNldCAodGFyZ2V0LCBrZXlzLCB2YWx1ZSkge1xuICBpZiAoa2V5cy5sZW5ndGgpIHtcbiAgICBsZXQgaGVhZCAgPSBrZXlzWzBdXG4gICAgbGV0IGNsb25lID0gbWVyZ2Uoe30sIHRhcmdldClcblxuICAgIGNsb25lW2hlYWRdID0ga2V5cy5sZW5ndGggPiAxID8gc2V0KGNsb25lW2hlYWRdIHx8IHt9LCBrZXlzLnNsaWNlKDEpLCB2YWx1ZSkgOiB2YWx1ZVxuXG4gICAgcmV0dXJuIGNsb25lXG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIHZhbHVlXG4gIH1cbn1cbiJdfQ==




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/update.js
 ** module id = 94
 ** module chunks = 0
 **/